import React, {Component} from 'react'

import * as firebase from 'firebase'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import Paper from 'material-ui/Paper';
import { red100 } from 'material-ui/styles/colors';

const style = {
    margin: 20,
    textAlign: 'center',
    display: 'inline-block',
  };


export default class UserCard extends Component {
    constructor(props) {
        super(props)
        this.state = {
          details: 'This promotion is only for new customers\n If you receive this message by mistake, feel free to reach out to us!',
          promo_image: 'logo.png',
          short_description: 'This link is not valid with your account!',
          title: 'Link Expired!'
        }
    }

    componentWillMount() {
        let self = this
        firebase.database().ref("promos/firstServicePromo").on("value", function(snap) {
            if(snap.val()) {
                let { details, promo_image, short_description, title } = snap.val();
                firebase.database().ref("info/referrals/" + self.props.uid).set({
                  converted: false,
                  referee: self.props.refereeKey
                })
                self.setState({
                    details: details,
                    promo_image: promo_image,
                    short_description: short_description,
                    title: title
                })
            }
        })
    }

    render() {
        return (
        <Card style={{background: '#FFFFFF'}}>
            <CardHeader
                titleColor='#838383'
                subtitleColor='#A9A9A9'
                title={this.props.userName}
                subtitle={this.props.userEmail}
                avatar={this.props.photoUrl}/>
            <CardTitle className="center" title="Petals Loyalty Rewards" subtitle="The Following Promo has Been Applied to Your Account!" />
            <CardText className="center">
            <Paper style={style} zDepth={3}>
                <Card style={{background: '#251B32'}}>
                    <CardHeader
                        titleColor='#DCA3AC'
                        subtitleColor='#DCA3AC'
                        title={this.state.title}
                        subtitle={this.state.short_description}
                        avatar={this.state.promo_image} />
                    <CardText>
                        <p style={{whiteSpace: 'pre-line', color: '#DCA3AC'}}>{this.state.details}</p>
                    </CardText>
                </Card>
            </Paper>

            </CardText>
        </Card>
        )
    }

}



// WEBPACK FOOTER //
// ./src/react/UserCard.js